import { atom, useRecoilState } from 'recoil';

import { LaneInput } from '@kinetic-ui/data-layer';
import { RecursivePartial } from 'types';
import { recoilKeys } from 'const';

export const selectedManeuverLaneState = atom<RecursivePartial<LaneInput> | undefined>({
  key: recoilKeys.SELECTED_MANEUVER_LANE,
  default: undefined,
});

export const useSelectedManeuverLane = () => {
  const [selectedManeuverLane, setSelectedManeuverLane] = useRecoilState(selectedManeuverLaneState);

  return { selectedManeuverLane, setSelectedManeuverLane };
};
